'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var Trash3 = function Trash3(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 13 15' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement(
        'title',
        null,
        'Page 1'
      ),
      _react2.default.createElement('path', { d: 'M11 12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h9v9zM5 1.5c0-.271.24-.5.525-.5h1.867c.301 0 .608.252.608.5V2H5v-.5zM9 2v-.5C9 .701 8.249 0 7.392 0H5.525C4.684 0 4 .673 4 1.5V2H0v1h1v9a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V3h1V2H9zm-1 9h1V5H8v6zm-2 0h1V5H6v6zm-2 0h1V5H4v6z',
        fill: 'currentColor', fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = Trash3;
//# sourceMappingURL=Trash3.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/Trash3.js